module.exports = __webpack_public_path__ + "img/user.94e38abe.png";